// app/javascript/projects/components/TeamModalDetail.jsx

import React from 'react';
import { Button } from 'ui'
import UserCircle from './UserCircle'
import { useSubscription, useSeats } from '../../hooks/subscriptions/queries';
import { calculateInitials } from '../../utils/userUtils';

function TeamModalDetail({ navigateToPage, PAGES, pageData }) {
  const { data: subscription } = useSubscription();
  const { data: seatsData } = useSeats(subscription?.id);
  
  const seatId = pageData?.seatId;
  const seats = seatsData?.seats || [];
  const seat = seats.find(s => s.id === seatId) || {};
  const user = seat.user || {};

  const removeSeat = () => {
    navigateToPage(PAGES.MEMBER_DELETE, { seatId });
  };

  return (
    <div style={{textAlign:"center"}}>
      <div style={{margin:"0 auto", width:"45px"}}>
        <UserCircle initials={calculateInitials(user)}/>
      </div>
      <h4 style={{marginBottom:0, marginTop:30}}>{user.name}</h4>
      <p>{user.email}</p>

      <div style={{marginTop:40, marginBottom:40}}>
        <div style={{margin:"0 auto", maxWidth:"250px"}}>
          <p style={{maxWidth:"250px"}}>If you remove this acount from your team, they will no longer be able
            to access projects in Delve.
          </p>
        </div>
      </div>

      <div style={{marginBottom:40}}>
        <Button variant="white" onClick={removeSeat}>Remove Team Member</Button>
      </div>
    </div>
  );
}

export default TeamModalDetail;